import header from '../images/header.png';

const Header: React.FunctionComponent<void> = () => (
    <header className="App-header">
      <img className="header" src={header} alt="header" />
    </header>
  )

export default Header
